<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useHeaderAssignmentTemplates } from '../../../model/assignments/header-assignment-templates.hook'

defineOptions({
  name: 'HeaderAssignmentTemplates',
})

const {
  refConfig,
} = useHeaderAssignmentTemplates()
</script>

<template>
  <div class="box-assignment-templates-header">
    <NavigationBreadcrumbs :config="refConfig" />
  </div>
</template>

<style scoped lang="scss" src="./HeaderAssignmentTemplates.scss" />
